import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DosageUnit } from 'src/interfaces/medicine';

/** Ensures the control holds a selected DosageUnit object, not free text. */
export function dosageUnitSelectedValidator(control: AbstractControl): ValidationErrors | null {
  const value: DosageUnit | string | null = control.value;

  if (!value || typeof value !== 'object' || typeof value.id !== 'number') {
    return { dosageUnitRequired: true };
  }

  return null;
}
